export const getPriceLists = (estimateId) =>
  fetch(`/agencies/estimates/${estimateId}/price_lists.json`)
    .then(response => response.json());

export const getActivePriceList = ({ search, organizationId, date }) => {
  const uri = `/organizations/${organizationId}/price_lists/active.json?search=${search}&date=${date}`
  return fetch(uri).then(response => response.json())
}
